export default function extEStCalcSZ(einkommen, freibetrag) {
  let berechneteSteuer = einkommen - freibetrag;
  if (berechneteSteuer > 0) {
    berechneteSteuer = berechneteSteuer * 0.06;
  } else {
    berechneteSteuer = 0;
  }
  return berechneteSteuer;
}
